var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerschmutzung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 34.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3a3a3a;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_382",
    "data-name": "Gruppe 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ws9KBi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_360",
    "data-name": "Gruppe 360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_803",
    "data-name": "Pfad 803",
    className: "cls-1",
    d: "M48,1.22c-4.36,1.13-6.72,3.94-5.47,8.27a1.13,1.13,0,0,1-.28,1.35,5.62,5.62,0,0,0-1.67,3.75,1,1,0,0,1-.58.93c-1.84,1.07-4.54,5.61-3.61,7.6,1,2.18,5.28,3.19,7.32,2.3a11.48,11.48,0,0,0,1.5-1.09,1.36,1.36,0,0,1,.82-.31,6,6,0,0,0,6.66-5.14,5.52,5.52,0,0,0,0-.71,1,1,0,0,1,.63-.93A8.17,8.17,0,0,0,58,9.54a8.87,8.87,0,0,0-5.61-8.07A7.38,7.38,0,0,0,48,1.22Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_354",
    "data-name": "Gruppe 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gordini-2"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_150",
    "data-name": "Linie 150",
    className: "cls-1",
    x1: 1.07,
    y1: 27.33,
    x2: 6.28,
    y2: 27.31
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_801",
    "data-name": "Pfad 801",
    className: "cls-1",
    d: "M17.75,27.28l6.65,0a2,2,0,0,0,1.94-2l0-8.33a4.05,4.05,0,0,0-.67-2.18L20.55,7.2c-.49-1-1.79-2.86-2.88-2.86L1,4.4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    className: "cls-1",
    cx: 12.01,
    cy: 27.3,
    r: 5.73
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_804",
    "data-name": "Pfad 804",
    className: "cls-1",
    d: "M26.94,20.85h4.65v4H26.35"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerschmutzung);
export default __webpack_public_path__ + "static/media/Verschmutzung.ccad4974ff28c86aaf3e15962d4aea8c.svg";
export { ForwardRef as ReactComponent };